module.exports = __webpack_public_path__ + "img/TrueGamers-bg.1370c2c9.jpg";